module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "318bb7a02ee3d_001.1c06402a.webp";